import React, { Component } from "react";
import { configHeaderVariant, indentByCabangConfig } from "./config";
import * as R from "ramda";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class IndentReportByCabang extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      tableConfig: [...configHeaderVariant],
    };
  }

  componentDidMount() {
    this.fetchData();
    this.setState((prev) => ({
      ...prev,
      tableConfig: [
        ...configHeaderVariant,
        ...this.props.dataCabang.map((item) => ({
          name: item.namaDealer,
          label: item.namaDealer,
          options: { sort: false },
        })),
        { name: "totalDataVariant", label: "Total", options: { sort: false } },
      ],
    }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.doSearch !== this.props.doSearch && this.props.doSearch) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    this.props.handleTriggerLoading();
    let dataKodeCabang = this.props.search;
    if (this.props.isAllSelected) {
      dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
    }
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanIndenCabang,
      setError: this.props.setError,
      menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Inden Perbulan",
      args: {
        kodeCabang: dataKodeCabang,
        // employeeIdTeamLeader: this.props.idLeader,
      },
    });
    this.props.handleTriggerLoading();
    this.props.onSuccessSearch();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const transformed = res.data.data.map((item) => {
        const { data = [], ...rest } = item;
        return {
          ...rest,
          ...Object.fromEntries(
            data.map((item) => [item.namaCabang, item.amountPerCabang]),
          ),
        };
      });
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: transformed,
      }));
    }
  };

  render() {
    return (
      <>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={indentByCabangConfig(this.props.field)}
          options={{ pagination: false, serverSide: false }}
        />
      </>
    );
  }
}

export default IndentReportByCabang;
